import React from 'react'

import prof_bg from '../../../assets/ww.png'
import man_camera from '../../../assets/man_camera.png'
import amaka from '../../../assets/amaka.png'
import peter from '../../../assets/peter.png'
import sophia from '../../../assets/sophia.png'
import noah from '../../../assets/noah.png'
import bozzy from '../../../assets/bozzy.png'
import ProfessionalBox from './ProfessionalBox'

const HomeProfessionals = () => {
	const profs = [
		{
			id: 1,
			image: amaka,
			name: 'Amaka Cross',
			role: 'Photographer/Cinematographer',
			no_of_projects: 105,
		},
		{
			id: 2,
			image: peter,
			name: 'Peter Parker',
			role: 'Cinematographer',
			no_of_projects: 15,
		},
		{
			id: 3,
			image: man_camera,
			name: 'David Bambam',
			role: 'Movie Director',
			no_of_projects: 1,
		},
		{
			id: 4,
			image: sophia,
			name: 'Sophia Stone',
			role: 'Graphics Effect Artisit',
			no_of_projects: 5,
		},
		{
			id: 5,
			image: noah,
			name: 'Noah Emeka',
			role: 'Photographer',
			no_of_projects: 32,
		},
		{
			id: 6,
			image: bozzy,
			name: 'Bozzy',
			role: 'Movie Director',
			no_of_projects: 0,
		},
	]

	return (
		<section
			className='homepage_profs'
			style={{ background: `url(${prof_bg})` }}
		>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12 text-center mb-2'>
						<h3 className='section_header'>Professionals on board</h3>
					</div>

					<div className='padbox'>
						<div className='row'>
							<ProfessionalBox profs={profs} />
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default HomeProfessionals
